<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Serviços de Enfermagem"
    >
        <Form
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <template>
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="handleSave"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Enums
import status from '@/enums/pronto-atendimento/statusExame'

export default {
    components: { Form },
    data: () => ({
        model: null,
        enums: { status }
    }),
    methods: {
        open(item) {
            if (item) {
                this.model = Object.assign({}, {
                    id: item.id,
                    procedimento: item.procedimento,
                    observacoes: item.observacoes,
                    status: item.status,
                    cid: item.cid,
                    horarioRealizacao: item.horarioRealizacao,
                })
            } else {
                this.model = Object.assign({}, {
                    id: null,
                    procedimento: null,
                    observacoes: null,
                    status: {
                        id: this.enums.status.SOLICITADO
                    },
                    cid: null,
                    horarioRealizacao: null
                })
            }

            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.handleExit()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>